function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Date, Object, reportsDrawer, requestAnimationFrame) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['cell-report-icon'] = function(report) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const icon = report.displayOptions.chartType;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            [`icon-${icon}`]: true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": {
              icon,
              color: $helpers.getReportIconColor(icon)
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['cell-report-actions'] = function(report) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`delete-enabled`) && report.can_update_basic) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": {
              icon: `trashcan`
            },
            "on": {
              click: ev => $helpers.clickDelete(ev, report)
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };
    return {
      value: (h("div", {
        "class": {
          'reports-list-wrapper': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-drawer", {
          "attrs": {
            open: $attr(`open`)
          },
          "on": {
            close: $helpers.close
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'reports-drawer-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'user-filter': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
                "attrs": {
                  selected: reportsDrawer.userFilter,
                  theme: `lite`,
                },
                "on": {
                  select: $helpers.changeUserFilter,
                },
                "class": Object.assign({}, {
                  'with-default-reports': $attr(`ootb-default-reports-enabled`),
                }, {
                  'user-filter-toggle': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                  "attrs": {
                    value: `all`
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("All");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(($attr(`ootb-default-reports-enabled`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                    "attrs": {
                      value: `default`
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Default");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("mp-toggle-option", {
                  "attrs": {
                    value: `yours`
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Your reports");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'reportlist-search': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
                "attrs": {
                  icon: `search`,
                  placeholder: `Search reports`,
                  value: reportsDrawer.searchFilter,
                },
                "on": {
                  input: $helpers.changeSearchFilter,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(($attr(`open`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'reports': true
                },
              }, (function() {
                var __jade_nodes = []; /*  we want the browser built-in Date.parse which is much faster */
                /*  and not the date.es5.js imposter Date.parse */
                const dateParse = Date._parse || Date.parse;;
                __jade_nodes = __jade_nodes.concat(h("mp-table", {
                  "attrs": {
                    'track-name': `insights-bookmark-drawer`,
                    'search-filter': reportsDrawer.searchFilter,
                    'default-sort-field': `modified`,
                    'default-sort-order': -1,
                    'empty-message': 'You don\'t have any saved reports yet.',
                    'loading': $attr(`loading`),
                    'style-override': require('./table-cells.styl?inline'),
                  },
                  "on": {
                    rowClick: $helpers.handleTableRowClick,
                  },
                  "hook": {
                    insert: ({
                      elm
                    }) => requestAnimationFrame(
                      () => elm.setAttribute('max-body-height', `calc(100vh - ${elm.offsetTop + 40}px)`)
                    )
                  },
                  "props": {
                    rows: $helpers.reportsForDisplay(),
                    columns: [{
                        field: `icon`,
                        flexBasis: `22px`,
                        cellRenderer: $mixins[`cell-report-icon`],
                      },
                      {
                        title: `Report`,
                        field: `title`,
                        type: `text-link`,
                        flexGrow: `1`,
                        isSearchable: true,
                        isSortable: true,
                      },
                      {
                        title: `Creator`,
                        field: `user`,
                        flexBasis: `60px`,
                        isSearchable: true,
                        isSortable: true,
                      },
                      {
                        title: `Last Modified`,
                        field: `modified`,
                        flexBasis: `110px`,
                        isSortable: true,
                        labelTransform: report => report.modifiedStr,
                        sortTransform: report => dateParse(report.modified),
                      },
                      {
                        field: `actions`,
                        flexBasis: `22px`,
                        cellRenderer: $mixins[`cell-report-actions`],
                      },
                    ],
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'drawer-close-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: 'x'
                },
                "on": {
                  click: $helpers.close
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        const toDelete = reportsDrawer.confirmDelete;
        __jade_nodes = __jade_nodes.concat((toDelete) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("bookmark-mp-confirm", {
            "attrs": {
              theme: `delete`,
              open: !!toDelete,
              closeable: true
            },
            "on": {
              change: ev => $helpers.handleConfirmChange(ev.detail.state),
              submit: ev => ev.detail.action === `confirm` && $helpers.deleteReport(toDelete),
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-confirm-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Delete report");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-confirm-description': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Are you sure you want to delete \"" + (toDelete.title) + "\"?");
                __jade_nodes = __jade_nodes.concat("  This action is permanent and cannot be undone.");
                __jade_nodes = __jade_nodes.concat((toDelete.include_in_dashboard) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("br"));
                  __jade_nodes = __jade_nodes.concat(h("br"));
                  __jade_nodes = __jade_nodes.concat("Deleting it will also remove it from all dashboards.");;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Date" in locals ? locals.Date : typeof Date !== "undefined" ? Date : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "reportsDrawer" in locals ? locals.reportsDrawer : typeof reportsDrawer !== "undefined" ? reportsDrawer : undefined, "requestAnimationFrame" in locals ? locals.requestAnimationFrame : typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;